import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-party-ink" data-id="element-178" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-179" data-mp="3b1487m19019j">
        <h2 id="testimonios" className="font-display text-lg font-extrabold leading-tight text-white sm:text-2xl" data-id="element-180" data-mp="36yzfcpimj8ny">
          Lo que dicen quienes ya empezaron
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-[0.8rem] leading-snug text-white/80" data-id="element-181" data-mp="2x0tfedgdoclq">
          De no saber por dónde comenzar a comprender cómo crear una decoración
          completa.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-182" data-mp="v9ga3nai02p5">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border-l-4 border-party-rose bg-white p-2.5 text-left text-party-ink" data-id="element-183" data-mp="qac22zzb8b0e" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-184" data-mp="m62sadkwqny2">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={12} className="fill-party-gold text-party-gold" data-id="element-185" data-mp="79v99gl8jskd" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1 text-[0.78rem] italic leading-snug" data-id="element-186" data-mp="zysdifsm3ou4">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto pt-1.5" data-id="element-187" data-mp="q7eiolblvd7b">
                <p className="font-sans text-[0.75rem] font-extrabold uppercase text-party-rose" data-id="element-188" data-mp="q6cx3mwyr8bc">
                  {t.author}
                </p>
                <p className="text-[0.66rem] leading-snug text-party-ink/60" data-id="element-189" data-mp="1ius71v18n0ft">
                  {t.role} · {t.location}
                </p>
              </div>
            </Reveal>)}

          <Reveal as="li" delay={0.15} className="flex h-full flex-col items-center justify-center rounded-lg border-2 border-dashed border-party-gold bg-party-charcoal p-3" data-id="element-190" data-mp="1xiitaylvbojr">
            <CtaButton href={OFFER_ANCHOR} data-id="element-191" data-mp="1og9l4fe2o79j">🚀 Sí, quiero comenzar ahora</CtaButton>
            <p className="mt-1.5 text-[0.68rem] font-semibold text-white/80" data-id="element-192" data-mp="1jirb0lobjlzy">
              Acceso Inmediato • Garantía de 7 Días
            </p>
          </Reveal>
        </ul>
      </div>
    </section>;
}